import { DependencyItemCard } from '../dependency-card-item/types';

export interface DependenciesDialogData {
  parent: DependencyItemCard;
  current: DependencyItemCard;
  children: DependencyItemCard[];
}
